// Registro mínimo del service worker de notificaciones push (public/service-worker.js).
// A diferencia del template clásico de CRA, este NO cachea assets ni implementa modo
// offline — solo existe para poder recibir "push" del servidor aunque la pestaña esté
// cerrada. Por eso el registro es simple y no necesita la lógica de localhost/producción
// del template original.
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').catch((err) => {
        console.error('Error registrando el service worker:', err);
      });
    });
  }
}
